<template>
  <div class="rule-page">
    <div class="rule-card">
      <button class="close-btn" type="button" @click="closePage">×</button>
      <h1>个人信息授权与保护声明</h1>
      <div class="rule-content">
        <p>请您务必仔细阅读并了解本《个人信息授权与保护声明》 （以下简称为"本声明" ）</p>

        <p>您一旦主动在页面填写您的个人信息并进行提交操作，即意味着您同意我们按照本声明收集、使用、共享您的相关信息。若您不接受本声明，请勿登记您的个人信息。</p>

        <p>我们的页面和服务主要面向成人。我们不会主动收集未成年人的个人信息，如果您未满14周岁，请您在监护人陪同下仔细阅读并充分理解本声明，并征得监护人的同意后使用我们的服务及/或向我们提供信息</p>

        <h2>一、收集信息的原则及目的</h2>
        <p>1.保障为您所提供的产品或服务功能的正常实现。</p>
        <p>2.实现对您的推送功能。</p>
        <p>3.帮助我们维护和改进我们的产品或服务，提升用户体验。</p>

        <h2>二、如何收集和使用您的个人信息</h2>
        <p>我们将合法合规对您的个人信息进行采集、使用。</p>
        <p>您已知晓并同意在您下次浏览本落地页面时，我们会帮您预先填写您上次输入的历史信息以提升您的使用体验。您亦可拒绝使用预填充功能。</p>
        <p>（一）收集和使用您的个人信息的范围，下单及订单管理</p>
        <p>为了向您配送货物或提供相关服务，当您准备登记您的信息以促成交易的达成时，我们将相应收集您的姓名、手机号、地址、性别和身份证号码（仅特殊行业需要，如运营商、保险）。同时，所涉订单中会载明订单编号、您所购买的商品或服务信息、下单时间等。具体需要填写的信息可能会根据我们提供的产品/服务的不同而有所差异，请以届时向您展示的产品/服务以及所对应的要求填写相关个人信息。</p>
        <p>2.广告的定向推送</p>
        <p>为实现广告推送功能，在您进入本广告页面并同意本声明时，我们还可能会收集您的产品与/或服务的设备信息，包括网络身份标识信息（手机IPV4地址、IP） 、网络信息、手机硬件信息（电量、品牌、型号、内存、屏幕分辨率、CPU信息）和运营商信息、操作日志。</p>
        <p>（二）例外</p>
        <p>对于《信息安全技术个人信息安全规范》 5.6中规定的情形，我们收集、使用您的个人信息无需事先征得您的授权同意。</p>

        <h2>三、如何共享、转让您的个人信息</h2>
        <p>（一）共享</p>
        <p>仅为实现本声明之目的，我们可能会与关联公司、合作伙伴共享您的某些个人信息。对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的合规协定或做类似要求，以规范其处理个人信息的行为，并促使其具备个人信息的安全保障能力。</p>
        <p>我们将与以下授权合作伙伴共享您的信息：</p>
        <p>1，供应商、服务提供商和其他合作伙伴（包括相关代理商）。为向您进行货物配送及提供服务，我们可能会将您主动登记提供的信息向该商品及服务的提供商，以及为此目的所涉及的必要第三方进行共享，并由其在您已经向其授权的范围内使用，包括向您发送货物或与您进行必要的联系。</p>
        <p>2.广告、分析服务类的授权合作伙伴。我们可能会将您的匿名化或去标识化的个人信息及您的设备信息与广告、分析服务类的授权合作伙伴共享，以帮助其在不识别您的个人身份的前提下提升广告有效触达率。</p>
        <p>（二）转让</p>
        <p>我们不会将您的个人信息转让给任何第三方，但基于您的明确同意或法律法规要求或涉及合并、收购、分立、重组或破产清算的情况除外。</p>

        <h2>四、如何保存与保护您的个人信息我们的信息保护规则：</h2>
        <p>1，收集到您的个人信息后，在保障供应商、服务提供商和其他合作伙伴或必要第三方能够凭借相关信息进行货物发送或服务提供的基础上，我们将通过技术手段及时对数据进行匿名化或去标识化处理。</p>
        <p>2.我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露等。</p>
        <p>3.如果我们的管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，我们将及时将事件相关情况及时向您告知，难以逐一告知时，我们会采取公告的方式。同时，我们还将主动上报个人信息安全事件的处置情况。</p>
        <p>我们的信息保存方式：</p>
        <p>1.保存期限：您提供的个人信息，将在上文所声明的服务提供过程中持续授权我们使用。在您删除个人信息时，我们将视为您撤回了对于该等个人信息收集、使用或共享的授权和同意。</p>
        <p>2.保存地域：原则上，我们所采集到的您的个人信息将存储在中国境内。</p>

        <h2>五、您对个人信息享有的权利</h2>
        <p>按照中国相关的法律、法规、标准，我们保障您对自己的个人信息的更正权、删除权或授权撤回等相关权益。</p>
        <p>为实现本第五条所述权利，您可通过本声明第七条"如何联系我们"中所列明的联系方式与我们进行联系，我们在验证主体身份，确认相关要求和理由后，为您进行相应的更正、删除及授权撤回。</p>

        <h2>六、政策更新</h2>
        <p>基于服务优化或情况变更等事由，本声明会不定期进行更新。更新版本将通过在官方网站、广告落地页面等我们正在运营或进行合作的各类相关产品中发出，也请您访问我们网站及软件以便及时了解最新的《个人信息授权与保护声明》。</p>

        <h2>七、联系我们</h2>
        <p>您可通过广告落地页中的客服电话(4009966049)联系我们，我们将会在15个工作日内给您反馈。</p>

        <h2>八、争议解决</h2>
        <p>本声明的涉诉争议由运营主体所在地的人民法院管辖。</p>
      </div>
      <button class="confirm-btn" type="button" @click="closePage">确定</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RulePage',
  methods: {
    closePage() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.rule-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 16px;
  box-sizing: border-box;
}
.rule-card {
  position: relative;
  max-width: 900px;
  margin: 0 auto;
  background: #fff;
  border-radius: 16px;
  padding: 20px 16px 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
}
.close-btn {
  position: absolute;
  right: 12px;
  top: 8px;
  border: none;
  background: transparent;
  font-size: 28px;
  color: #999;
  line-height: 1;
}
.rule-card h1 {
  margin: 0 0 18px;
  text-align: center;
  font-size: 22px;
  color: #111;
}
.rule-content {
  color: #333;
  font-size: 14px;
  line-height: 1.8;
  max-height: calc(100vh - 180px);
  overflow-y: auto;
}
.rule-content h2 {
  margin: 18px 0 8px;
  font-size: 16px;
  color: #111;
}
.rule-content p {
  margin: 0 0 10px;
}
.confirm-btn {
  margin-top: 14px;
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 22px;
  background: #f4cd16;
  color: #d4451f;
  font-size: 16px;
  font-weight: 700;
}
</style>
